import { render } from "./App.vue?vue&type=template&id=11483420&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=11483420&lang=css"

import exportComponent from "D:\\a\\r1\\a\\_av-FAI Demo Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__